export default {"src":"/_next/static/media/icon_facebook.d07fe5a7.svg","height":24,"width":25};